/** @format */
import { Component, computed, DestroyRef, EventEmitter, input, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ValidatablePlan } from 'common-typescript';
import { OtmId, CourseUnit, CourseUnitResultItem, CurriculumPeriod } from 'common-typescript/types';
import { tap } from 'rxjs/operators';
import { AppErrorHandler } from 'sis-components/error-handler/app-error-handler';
import { PlanData, PlanStateObject } from 'sis-components/service/plan-state.service';
import { StudyRightEntityService } from 'sis-components/service/study-right-entity.service';
import { UniversitySettingsEntityService } from 'sis-components/service/university-settings-entity.service';
import { UniversityService } from 'sis-components/service/university.service';

@Component({
    selector: 'app-free-edit-course-unit-expandable',
    templateUrl: './free-edit-course-unit-expandable.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class FreeEditCourseUnitExpandableComponent implements OnInit {
    searchCurriculumPeriods = input<CurriculumPeriod[]>([]);
    @Input() validatablePlan: ValidatablePlan;
    @Input() planData: PlanData;
    @Input() planStateObject: PlanStateObject;
    @Input() allCourseUnits: CourseUnit[];
    @Output() toggledCourseUnit = new EventEmitter<{
        courseUnit: CourseUnit;
        isInPlan: boolean;
    }>();

    @Output() selectedCourseUnit = new EventEmitter<CourseUnitResultItem>();

    searchCurriculumPeriodIds = computed(() => this.searchCurriculumPeriods().map(cur => cur.id));

    currentUniversityOrgId: OtmId;
    crossStudyFeaturesEnabled = false;
    cooperationNetworkIds: OtmId[] = null;
    curriculumPeriodIds: OtmId[] = null;

    constructor(
        private readonly studyRightEntityService: StudyRightEntityService,
        private readonly universityService: UniversityService,
        private readonly universitySettingsService: UniversitySettingsEntityService,
        private readonly appErrorHandler: AppErrorHandler,
        private readonly destroyRef: DestroyRef,
    ) {
        this.currentUniversityOrgId = this.universityService.getCurrentUniversityOrgId();
    }

    ngOnInit(): void {
        this.curriculumPeriodIds = this.searchCurriculumPeriodIds();

        if (this.planStateObject?.studyRight) {
            this.cooperationNetworkIds = this.studyRightEntityService.getValidCooperationNetworkIds(this.planStateObject.studyRight);
        }

        this.universitySettingsService
            .getById(this.currentUniversityOrgId)
            .pipe(
                takeUntilDestroyed(this.destroyRef),
                tap(settings => {
                    this.crossStudyFeaturesEnabled = !!settings?.frontendFeatureToggles?.crossStudyFeaturesEnabledForStudent;
                }),
                this.appErrorHandler.defaultErrorHandler(),
            )
            .subscribe();
    }

    selectCourseUnitFromSelectList(courseUnit: CourseUnitResultItem): void {
        if (courseUnit) {
            this.selectedCourseUnit.emit(courseUnit);
        }
    }

    handleToggle(toggleData: { courseUnit: CourseUnit; isInPlan: boolean }): void {
        this.toggledCourseUnit.emit(toggleData);
    }

    getCourseUnitIdsExcludedFromSearch() {
        return new Set(this.allCourseUnits.map(item => item.id).concat(Object.keys(this.validatablePlan.courseUnitsById)));
    }
}
